function dobbleGameControl(conf){
    conf=$.extend(true,{
        howlong:4000,
        howlong_random:[100,100],
        onHit:function(){},
        onBonusStart:function(){},
        onBonusEnd:function(){}
    },conf);
    this.conf=conf;
    this.mili=1000/60;
    this.obj={
        step:0,
        step_max:0,
        step_last:0
    };
    this.is_bonus=0;
};
dobbleGameControl.prototype={
    init:function(){
        this.prepareNextStep();
    },
    prepareNextStep:function(){
        this.obj.step-=this.obj.step_max;
        var rand=mt_rand(this.conf.howlong_random[0],this.conf.howlong_random[1]);
        this.obj.step_max=rand/100*this.conf.howlong/this.mili;
    },
    add:function(step){
        this.obj.step+=step;
        if(this.obj.step>=this.obj.step_max){
            this.prepareNextStep();
            this.conf.onHit.call(this);
        }
        if(this.is_bonus && this.obj.step>0){
             this.is_bonus=0;
             this.conf.onBonusEnd();
        }
    },
    clear:function(){
        this.obj.step=Math.min(0, this.obj.step);
        this.obj.step_last=this.obj.step;
    },
    forceBonus:function(){
        var step=Math.min(0,this.obj.step)-this.obj.step_max*3/2;
        this.obj.step=step;
        if(this.is_bonus==0){
            this.is_bonus=1;
            this.conf.onBonusStart();
        }
    },
    minus:function(){
        
        var d=Math.min(this.obj.step_max,this.obj.step_max-this.obj.step);
        
        var step=Math.min(0,this.obj.step)-d/2;
        
        
        
        this.obj.step_last=this.obj.step;
        this.obj.step=step;
        if(this.is_bonus==0 && -step>this.obj.step_max/2){
            this.is_bonus=1;
            this.conf.onBonusStart();
        }
    }
    
}